/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { customFieldIndex } from '../../axios/customFieldIndex'
import type {
	CustomFieldIndexError,
	CustomFieldIndexPathParams,
	CustomFieldIndexResponse,
} from '../../types/CustomFieldIndex'

export const customFieldIndexQueryKey = (organisation: CustomFieldIndexPathParams['organisation']) =>
	[{ url: '/:organisation/custom_fields', params: { organisation } }] as const

export type CustomFieldIndexQueryKey = ReturnType<typeof customFieldIndexQueryKey>

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::index */
export function customFieldIndexQueryOptions(
	organisation: CustomFieldIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CustomFieldIndexResponse,
		AxiosError<CustomFieldIndexError>,
		CustomFieldIndexResponse,
		CustomFieldIndexQueryKey
	>({
		queryKey: customFieldIndexQueryKey(organisation),
		queryFn: ({ signal }) => customFieldIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::index */
export function useCustomFieldIndex<TSelectData = CustomFieldIndexResponse>(
	organisation: CustomFieldIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CustomFieldIndexResponse,
					AxiosError<CustomFieldIndexError>,
					TSelectData,
					CustomFieldIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CustomFieldIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...customFieldIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::index */
export function useCustomFieldIndexSuspense<TSelectData = CustomFieldIndexResponse>(
	organisation: CustomFieldIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CustomFieldIndexResponse,
					AxiosError<CustomFieldIndexError>,
					TSelectData,
					CustomFieldIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CustomFieldIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...customFieldIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
